import * as React from 'react'

/**
 * A banner-shaped loading placeholder.
 *
 * Reuses {@link Hero}'s own geometry class (`mlsg-hero`) so the reserved box is
 * exactly the one the banner will occupy — that identity is what keeps the swap
 * free of layout shift, the same contract {@link MovieTileSkeleton} keeps for a
 * tile. The banner is the tallest thing on a page (600–800px), so it is also the
 * single largest shift the page can produce: everything below it moves by the
 * banner's full height when it arrives unreserved.
 *
 * Rendered while the hero topic request is in flight. A domain with no hero
 * configured answers 404 and the caller then drops the placeholder — one collapse,
 * on the domains that never show a banner at all, in exchange for no shift on the
 * domains that always do.
 *
 * Purely decorative, so it is hidden from assistive technology; the page around it
 * is what announces that it is busy.
 */
export function HeroSkeleton () {
  return (
    <div className='mlsg-hero mlsg-hero--skeleton' aria-hidden='true'>
      <div className='mlsg-hero__content'>
        {/* The title and copy lines the banner will fill, at the banner's own
            metrics, so the content block inside the reserved box does not shift
            either when the real text lands. */}
        <div className='mlsg-skeleton mlsg-hero__skeleton-title' />
        <div className='mlsg-skeleton mlsg-hero__skeleton-text' />
        <div className='mlsg-skeleton mlsg-hero__skeleton-text mlsg-hero__skeleton-text--short' />
      </div>
      <div className='mlsg-hero__overlay' />
    </div>
  )
}
